<script setup>
import { Primitive } from "reka-ui";
import { cn } from "@/lib/utils";
import { buttonVariants } from ".";
import { Spinner } from '@/components/ui/spinner/index.js'

const props = defineProps({
  variant: { type: null, required: false, default: 'default' },
  size: { type: null, required: false, default: 'default' },
  class: { type: null, required: false, default: null },
  asChild: { type: Boolean, required: false },
  loading: { type: Boolean, required: false },
  block: { type: Boolean, required: false },
  as: { type: null, required: false, default: "button" },
});
</script>

<template>
  <Primitive :disabled="loading" :as="as" :as-child="asChild" :class="cn(buttonVariants({ variant, size, loading, block }), props.class)">
    <slot v-if="!loading" />
    <spinner v-if="loading" /> <slot v-if="loading" name="loading" />
  </Primitive>
</template>
